export const MY_CHATS_PAGE_SIZE = 5;
export const UNASSIGNED_CHATS_PAGE_SIZE = 5;
export const QUEUED_CHATS_PAGE_SIZE = 5;
export const SUPERVISED_CHATS_PAGE_SIZE = 5;

export const UNASSIGNED_CHAT_LAST_MESSAGE_PLACEHOLDER = 'Waiting for reply';
